var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1121_14530",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1121_14530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70803 20.4C5.4532 20.4 5.23828 20.3142 5.06328 20.1427C4.88828 19.9712 4.80078 19.7587 4.80078 19.5052C4.80078 19.2517 4.88695 19.0375 5.05928 18.8625C5.23178 18.6875 5.44545 18.6 5.70028 18.6H18.2935C18.5484 18.6 18.7633 18.6857 18.9383 18.8572C19.1133 19.0287 19.2008 19.2412 19.2008 19.4947C19.2008 19.7482 19.1146 19.9625 18.9423 20.1375C18.7698 20.3125 18.5561 20.4 18.3013 20.4H5.70803ZM11.9958 16.425C11.8758 16.425 11.7633 16.4041 11.6583 16.3625C11.5533 16.3208 11.4591 16.2583 11.3758 16.175L7.82228 12.6215C7.64128 12.4405 7.55495 12.2291 7.56328 11.9875C7.57162 11.7458 7.66745 11.5333 7.85078 11.35C8.03412 11.1666 8.24662 11.075 8.48828 11.075C8.72995 11.075 8.94245 11.1666 9.12578 11.35L11.1008 13.35V4.49998C11.1008 4.24498 11.1865 4.03122 11.358 3.85872C11.5295 3.68622 11.742 3.59998 11.9955 3.59998C12.249 3.59998 12.4633 3.68622 12.6383 3.85872C12.8133 4.03122 12.9008 4.24498 12.9008 4.49998V13.35L14.9008 11.35C15.0841 11.1666 15.2966 11.0791 15.5383 11.0875C15.78 11.0958 15.9924 11.1916 16.1758 11.375C16.3591 11.5583 16.4508 11.7708 16.4508 12.0125C16.4508 12.2541 16.3603 12.4649 16.1793 12.6447L12.6258 16.175C12.5358 16.2583 12.4383 16.3208 12.3333 16.3625C12.2283 16.4041 12.1158 16.425 11.9958 16.425Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.2d44cbc7c983b3fe99f5d8e413414dde.svg";
export { ForwardRef as ReactComponent };